<div class="case-number-cell">
  @if (navigable()) {
    <cm-link
      class="case-number"
      [class.has-notification]="hasUnread()"
      [routerLinkName]="routerLinkName()"
      [showIcon]="false"
      [ariaLabel]="linkAriaLabel()"
      [autId]="linkAutId()"
      color="dark"
    >
      {{ caseNumber() }}
    </cm-link>
  } @else {
    <span
      class="case-number"
      [class.has-notification]="hasUnread()"
      [attr.aut-id]="'case-number-' + caseId()"
    >
      {{ caseNumber() }}
    </span>
  }
  @if (showCommentsButton()) {
    <div class="case-number-cell__actions">
      <cm-action-button
        [iconName]="'chat_bubble'"
        [ariaLabel]="commentsAriaLabel()"
        [title]="commentsAriaLabel()"
        [autId]="'case-comments-button-' + caseNumber()"
        (click)="onCommentsClick($event)"
      />
      @if (hasUnread()) {
        <span class="case-number-cell__badge" [cmTooltip]="commentsAriaLabel()">{{ unreadMessageCount() }}</span>
      }
    </div>
  }
</div>
